import React, { useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { assessmentsApi } from '../../../../utils'
import fromDevice from '../../../../assests/assessments/new/from-device.png'
// import fromLibrary from '../../../../assests/assessments/new/from-library.png'
import DeleteIcon from '../../../../assests/assessments/new/delete-icon.png'
import Card from '../../../UI/Card';
import classes from "./Attachments.module.css";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { DynamicFileThumbnail } from '../../../lms-shared/functions/DynamicFileThumbnail'
import { onKeyDown } from "../../../../service";
import { AttachmentTypeEnumText } from "../../../lms-shared/models/AttachmentTypeEnum";


const Attachments = forwardRef(({ assessment, handleChangeContentData }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const [fromSelected, setFromSelected] = useState({ device: false, library: false })
    const dispatch = useDispatch()

    const chooseFromDevice = (e) => {
        if (e.target.files) {
            setFromSelected({ device: true, library: false })
            const data = {
                id: assessment.id,
                fileDescription: e.target.files[0].name,
                attachmentType: AttachmentTypeEnumText.File,
                file: e.target.files[0],
            }
            assessmentsApi.assessmentsAddFilePost(data, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsAddFilePost " + error.message, level: 1, component: "Attachments", line: 27 }))
                }
                else {
                    console.log('resdata', resdata);
                    handleChangeContentData(resdata)
                }
            })
        }
    }

    const DeleteFile = (f) => {
        const data = {
            id: assessment.id,
            fileId: f.Id
        }
        assessmentsApi.assessmentsDeleteFilePost({ deleteFileInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "assessmentsDeleteFilePost " + error.message, level: 1, component: "Attachments", line: 44 }))
            }
            else {
                console.log('resdata', resdata);
                handleChangeContentData(resdata)
            }
        })
    }

    return (
        <div className={`${classes.AttachmentsWrapper} ${classes.Overflow}`}>
            <div className={classes.Attachments}>
                <div className={classes.AddAttachmentsWrapper}>
                    <h2 className={classes.AddAttachmentsText}>{texts.nowAddAttachments}</h2>
                    <div className={classes.AddAttachments}>
                        {/* <div className={`${classes.AddAttachment} ${fromSelected.library && classes.WrapSelected}`}
                            onClick={() => setFromSelected({ device: false, library: true })}>
                            <Card>
                                <div className={classes.Content} style={{ backgroundImage: `url(${fromLibrary}` }}></div>
                                <div className={classes.ContentText}>{texts.fromLibrary}</div>
                            </Card>
                        </div> */}
                        <div className={`${classes.AddAttachment} ${fromSelected.device && classes.WrapSelected}`}>
                            <Card>
                                <input className={classes.FileInput} onClick={(e) => e.target.value = ''} onChange={chooseFromDevice} type="file" id="FileInput" multiple tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => e.target.value = '')} />
                                <div className={classes.Content} style={{ backgroundImage: `url(${fromDevice}` }}></div>
                                <div className={classes.ContentText}>{texts.fromDevice}</div>
                            </Card>
                        </div>
                    </div>
                </div>
                <div className={classes.AttachmentsChosenWrapper}>
                    <h2 className={classes.AttachmentsChosen}>{texts.attachmentsToAssessment}:</h2>
                    <div className={classes.AttachmentsChosenTextWrapper}>
                        <h3 className={classes.AttachmentsChosenText}>{texts.canAddAttachments}</h3>
                        <img className={classes.Delete} alt="DeleteIcon" src={DeleteIcon} style={{ cursor: "default" }} />
                    </div>
                    <div className={`${classes.ShowAttachmentsChosenWrapper} ${classes.Overflow}`}>
                        <div className={classes.ShowAttachmentsChosen}>
                            {assessment.attachments && assessment.attachments.length > 0 && assessment.attachments.map((f, i) => {
                                const thumbnail = DynamicFileThumbnail(f.FileSubUrl, assessment.filesBaseUrl)
                                return <div className={classes.FileWrapper} key={i}>
                                    <div className={classes.FileNum}>{i + 1}</div>
                                    <div className={classes.File} key={i}>
                                        <div className={classes.FileImg}>
                                            <img className={classes.FileImgSrc} src={thumbnail} alt="thumbnail" />
                                            <img className={classes.Delete} src={DeleteIcon} alt="DeleteIcon" onClick={() => DeleteFile(f)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => DeleteFile(f))} />
                                        </div>
                                        <div className={classes.FileName}>{f.Description}</div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default Attachments;